"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var R = _interopRequireWildcard(require("ramda"));
var _formik = require("formik");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _static = require("@otpusk/json-api/dist/static");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _config = require("../../../../services/config");
var _Button = _interopRequireWildcard(require("../../../ui/Button"));
var _Label = _interopRequireDefault(require("../../../ui/Label"));
var _styles = _interopRequireDefault(require("./styles"));
var _excluded = ["getBackground"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LOCALES_BY_CODE = {
  yes: 'IS',
  request: 'BY_REQUEST',
  no: 'NO'
};
var LABELS_BY_TYPE = _defineProperty(_defineProperty({}, _fn.QUERY_PARAMS.FLIGHT_AVAILABILITY, 'AVAILABILLITY_FLIGHT_CONTROL_LABEL'), _fn.QUERY_PARAMS.HOTEL_AVAILABILITY, 'AVAILABILLITY_HOTEL_CONTROL_LABEL');
var getExternalProps = function getExternalProps(isActive) {
  return R.call(R.ifElse(Boolean, function (_ref) {
    var getBackground = _ref.getBackground,
      externalProps = _objectWithoutProperties(_ref, _excluded);
    return _objectSpread({}, externalProps, {
      background: getBackground(isActive)
    });
  }, R.always({})), (0, _config.getAvailabilityControlInSearchForm)());
};
var AvailabilityControl = function AvailabilityControl(_ref2) {
  var type = _ref2.type;
  var _useTranslation = (0, _reactI18next.useTranslation)(['AVAILABILLITY_OPTIONS', 'SEARCH_FORM']),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_Label.default, {
    clickable: false,
    text: t(LABELS_BY_TYPE[type])
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.checkboxes
  }, /*#__PURE__*/_react.default.createElement(_formik.FastField, {
    name: type,
    render: function render(_ref3) {
      var field = _ref3.field,
        form = _ref3.form;
      return R.map(function (_ref4) {
        var code = _ref4.code;
        var isActive = R.includes(code, field.value);
        return /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
          key: code,
          size: _Button.SIZES.TINY,
          theme: isActive ? _Button.THEMES.PURPLE : _Button.THEMES.GRAY,
          onClick: function onClick() {
            return form.setFieldValue(field.name, isActive ? R.without([code], field.value) : R.append(code, field.value));
          }
        }, getExternalProps(isActive)), t(LOCALES_BY_CODE[code]));
      }, _static.AVAILABILITY);
    }
  })));
};
AvailabilityControl.propTypes = {
  type: _propTypes.default.oneOf([_fn.QUERY_PARAMS.FLIGHT_AVAILABILITY, _fn.QUERY_PARAMS.HOTEL_AVAILABILITY]).isRequired
};
var _default = exports.default = (0, _react.memo)(AvailabilityControl);